import React from 'react';
import { Accordion, Modal } from 'react-bootstrap';
import * as Bs from 'react-icons/bs';

const initialState = {
  isShow: false,
};

const Tutorial = () => {
  const [{ isShow }, setState] = React.useState(initialState);

  const clearState = () => {
    setState({ ...initialState });
  };

  const $handleClose = () => {
    clearState();
  };

  return (
    <>
      <div className="d-flex align-items-center py-2">
        <Bs.BsInfoCircleFill size={20} color="#2f83ba" className="me-2" />
        <span>
          Tambahkan manifest atau untuk mengatur pengiriman.{' '}
          <span
            className="fw-bold text-primary ms-1 text-decoration-underline cursor-pointer"
            onClick={() =>
              setState((prevState) => ({ ...prevState, isShow: true }))
            }
          >
            Pelajari Job Order
          </span>
        </span>
      </div>

      <Modal show={isShow} onHide={$handleClose} centered size="md">
        <Modal.Header className="text-center d-block p-0">
          <div className="py-3">
            <div className="fw-bold fs-6">Pelajari Manifest</div>
            <div className="fw-semibold">
              Anda bisa melihat pengiriman telah ditambahkan pada daftar
              shipment.
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="px-2 py-3">
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header className="pb-2">
                <div className="fs-6 fw-semibold">Apa itu manifest ?</div>
              </Accordion.Header>
              <Accordion.Body className="px-3 py-2 border-bottom">
                Manifest adalah sebuah dokumen yang berisi keterangan daftar
                shipment yang diangkut dalam suatu transportasi pengiriman.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header className="py-2">
                <div className="fs-6 fw-semibold">
                  Apa fungsi dari manifest ?
                </div>
              </Accordion.Header>
              <Accordion.Body className="px-3 py-2 border-bottom">
                Manifest digunakan untuk mengatur armada, routing dan proses
                pengiriman barang (atau lebih dikenal dengan surat jalan).
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header className="py-2">
                <div className="fs-6 fw-semibold">
                  Bagaimana cara membuat manifest ?
                </div>
              </Accordion.Header>
              <Accordion.Body className="px-3 py-2 border-bottom">
                Manifest dapat dibuat jika Anda sudah membuat data shipment.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header className="py-2">
                <div className="fs-6 fw-semibold">
                  Apakah manifest yang sudah dibuat bisa dihapus ?
                </div>
              </Accordion.Header>
              <Accordion.Body className="px-3 py-2 border-bottom">
                Manifest bisa dihapus apabila manifest tersebut belum di
                terbitkan.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header className="py-2">
                <div className="fs-6 fw-semibold">
                  Apa perbedaan manifest pengiriman dan penerimaan ?
                </div>
              </Accordion.Header>
              <Accordion.Body className="px-3 py-2 border-bottom">
                Manifest pengiriman merupakan manifest/pengiriman yang
                diterbitkan dan dikirim dari hub tersebut sedangkan manifest
                penerimaan merupakan manifest/pengiriman yang akan
                datang/diterima ke hub ( bisa berasal dari hub lain atau proses
                pick up barang ).
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Tutorial;
